import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import { getBrandConfig } from '@awaze/mfe-common.configs.brand'
import type { AccommodationType } from '@awaze/mfe-common.types-and-mocks.site-search-service'

import { DisplayMode } from '@/lib/display/displayContext'

const isDatedSearch = (start: string | undefined) => Boolean(start)
const chooseSortConfig = (
  accommodationType: AccommodationType | undefined,
  brand: Brand,
) =>
  accommodationType === 'cottages'
    ? getBrandConfig('cottages.com').sortOptions
    : getBrandConfig(brand).sortOptions

interface GetSortOptionsFromConfigArgs {
  accommodationType: AccommodationType | undefined
  brand: Brand
  startDate: string | undefined
}

export const getSortOptionsFromConfig = ({
  accommodationType,
  brand,
  startDate,
}: GetSortOptionsFromConfigArgs): string[] => {
  const sortConfig = chooseSortConfig(accommodationType, brand)
  const optionsConfig = isDatedSearch(startDate)
    ? sortConfig.dated
    : sortConfig.undated

  return optionsConfig.options
}

interface ShouldDisplaySortOptionsArgs {
  displayMode: DisplayMode
}

export const shouldDisplaySortOptions = ({
  displayMode,
}: ShouldDisplaySortOptionsArgs): boolean => displayMode === 'LIST'
